import { registry } from '@cian/mf-registry/browser';
import { IDesktopFiltersAPI, IDesktopFiltersResult } from '../../../shared/types/desktopFiltersApi';

const desktopFiltersApiCall = async <Result = IDesktopFiltersResult>(path: string): Promise<Result> => {
  const api = await registry().microfrontendStrict('desktop-filters-micro-frontend').api()?.ensure();

  return api?.call(path) as Result;
};

export const getDesktopFiltersMicrofrontendAPI = (): IDesktopFiltersAPI => {
  return {
    openAllFiltersModal: () => {
      return desktopFiltersApiCall<void>('/v1/open-all-filters-modal');
    },
    closeAllFiltersModal: () => {
      return desktopFiltersApiCall<void>('/v1/close-all-filters-modal');
    },
  };
};
